import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { assignShift } from "../../../core/data/redux/reportingEmployeesSlice";
import { getOfficeLocation } from "../../../core/data/redux/officeLocationSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchAll } from "../../../core/data/redux/workShiftSlice";

interface ShiftsProps {
  employee: any;
}

const Shifts = (props: ShiftsProps) => {
  const { employee } = props;

  const dispatch = useDispatch();
  const officeLocationState = useSelector(
    (state: any) => state.officeLocationState
  );
  const workShiftState = useSelector((state: any) => state.workShiftState);
  const [dataList, setDataList] = React.useState<any[]>([]);
  const [selectedShift, setSelectedShift] = React.useState<any | null>(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 10,
  });

  React.useEffect(() => {
    console.log("employee", employee?.employee?.shift?.shift_id);
    setSelectedShift(employee?.employee?.shift?.shift_id);
  }, [employee]);

  React.useEffect(() => {
    dispatch(
      fetchAll({ page: pagination.current, limit: pagination.pageSize })
    );
  }, []);

  const handleSelect = (id: any) => {
    setSelectedShift(id);
  };

  const handleAssign = async () => {
    const payload = {
      empId: employee.empId,
      shift_id: selectedShift,
    };
    await dispatch(assignShift(payload));
  };

  // React.useEffect(() => {
  //     const selectedOffice = employee?.offices ? employee.offices.map((item: any) => item.office_location_id) : [];
  //     setSelectedRows(selectedOffice);
  // }, [employee]);
console.log('workShiftState',workShiftState)
  React.useEffect(() => {

    
    if (
      workShiftState.loading === "fulfilled" &&
      workShiftState.action === "list"
    ) {
      const result = workShiftState?.data?.data || null;

      
      if (result.data && result.data.length > 0) {
        const roles = result?.data || [];
        setDataList(roles);
        setPagination({
          ...pagination,
          total: result.total || roles.length,
          current: result.page || 1,
          pageSize: result.limit || 10,
        });
      } else {
        setDataList([]);
      }
    }
  }, [workShiftState]);

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      width: 100,
      render: (text: string, record: any, index: number) => (
        <>
          <div style={{ display: "flex" }}>
            <div>
              {pagination.current
                ? index +
                  pagination.current * pagination.pageSize -
                  pagination.pageSize +
                  1
                : index + 1}
            </div>
            <div style={{ marginLeft: 10 }}>
              {selectedShift && selectedShift === record.id ? (
                <input
                  checked={true}
                  type="radio"
                  name="assign"
                  onChange={() => handleSelect(record.id)}
                ></input>
              ) : (
                <input
                  checked={false}
                  type="radio"
                  name="assign"
                  onChange={() => handleSelect(record.id)}
                ></input>
              )}
            </div>
          </div>
        </>
      ),
      sorter: (a: any, b: any) => a.id.length - b.id.length,
    },
    {
      title: "Shift Name",
      dataIndex: "shift_code",
      sorter: (a: any, b: any) => a.shift_code.length - b.shift_code.length,
    },
    {
      title: "Start Time",
      dataIndex: "start_time",
      sorter: (a: any, b: any) => a.start_time.length - b.start_time.length,
    },
    {
      title: "End Time",
      dataIndex: "end_time",
      sorter: (a: any, b: any) => a.end_time.length - b.end_time.length,
    },
  ];

  const handlePagination = (pagination: any) => {
    console.log('Paging......')
    setPagination({
      current: pagination.page,
      pageSize: pagination.pageSize,
      total: pagination.total || 10,
    });
    dispatch(
      fetchAll({ page: pagination.current, limit: pagination.pageSize })
    );
  };

  return (
    <div>
      <>
        <div className="pt-2">
          <Table
            columns={columns}
            dataSource={dataList}
            Selection={false}
            paginationConfig={pagination}
            handlePagination={handlePagination}
            loading={officeLocationState.loading === "pending"}
            scroll={{ y: 300 }}
          />
        </div>
        <div className="row align-items-center">
          <div className="col-md-12">
            <div className="datatable-paginate mt-4" />
            <div className="d-flex justify-content-center pb-3 pt-0">
              {selectedShift ? (
                <Link
                  to="#"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                  onClick={() => handleAssign()}
                >
                  Assign
                </Link>
              ) : (
                <Link
                  to="#"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Select to assign
                </Link>
              )}
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default Shifts;
